export const SET_STATE = 'SET_TEAM_STATE' // To make it easy, but this is a bad api
export const RESET = 'RESET_TEAM_STATE'

export const SET_CLASSROOM_TEAMS_ENABLED = 'SET_CLASSROOM_TEAMS_ENABLED'
export const SET_TEAMS = 'SET_TEAMS'
export const SET_TEAM_NAME = 'SET_TEAM_NAME'
export const ADD_TEAM = 'ADD_TEAM'


export const DELETE_TEAM= 'DELETE_TEAM'

export const ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER'
export const REMOVE_TEAM_MEMBER = 'REMOVE_TEAM_MEMBER'

export const MAKE_TEAM_CAPTAIN = 'MAKE_TEAM_CAPTAIN'
export const REVOKE_TEAM_CAPTAIN = 'REVOKE_TEAM_CAPTAIN'

export const SET_SELECTABLE_MEMBERS = 'SET_CLASSROOM_TEAMS_SELECTABLE_MEMBERS'

